import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading-screen">Loading...</div>; // You can add a better spinner here
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const isEmailUnverified = user.providerData.some(p => p.providerId === 'password') && !user.emailVerified;
  
  if (isEmailUnverified) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
